




import { createSlice } from '@reduxjs/toolkit';


const initialState = localStorage.getItem('last_screen') || 'settings';


const screenStateSlice = createSlice({
	name: 'screenState',
	initialState,
	reducers: {
		setScreen: (state, action) => {
			try { localStorage.setItem('last_screen', action.payload); } catch(e) {}
			return action.payload;
		},
	},
});


export const { setScreen } = screenStateSlice.actions;
export default screenStateSlice.reducer;